module.exports = __webpack_public_path__ + "img/connection.1ad43390.svg";